import styled from 'styled-components'

export const Container = styled.div`
  padding: 80px 112px;

  @media (max-width: 911px) {
    padding-inline: 24px;
  }

  @media (max-width: 912px) {
    padding-block: 40px;
  }
`

export const Content = styled.div`
  display: flex;
  gap: 32px;
  justify-content: space-around;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  @media (min-width: 912px) {
    & > .subjects {
      display: none;
    }
  }

  @media (max-width: 911px) {
    flex-direction: column;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  max-width: 384px;
  width: 100%;

  & > .header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > h6 {
      color: #00A988;
      font-size: 1rem;
      font-weight: 700;
      text-transform: uppercase;
    }

    & > h1 {
      color: #1D1D1D;
      font-size: 2rem;
      font-weight: 500;
    }

    & > p {
      color: #282733;
      font-size: 1.125rem;
      font-weight: 400;
    }
  }

  @media (max-width: 911px) {
    & > .subjects {
      display: none;
    }
  }
`

export const Subjects = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const Accordions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const SAC = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > p {
    color: #737185;
    font-size: 1rem;
    line-height: 140%;

    & > strong {
      color: #17161E;
    }
  }
`
